import React from 'react';
import { AlertTriangle } from 'lucide-react';

const RiskDisclaimer = ({ variant = "full" }) => {
  if (variant === "compact") {
    return (
      <div className="bg-red-50 border-l-4 border-red-500 p-4 my-6">
        <div className="flex items-start gap-3">
          <AlertTriangle className="text-red-600 flex-shrink-0 mt-0.5" size={20} />
          <div>
            <p className="text-red-900 text-xs font-semibold leading-relaxed">
              <strong>Risk Disclaimer:</strong> Mutual fund investments are subject to market risks. Please read all scheme-related documents carefully before investing. Past performance is not indicative of future returns.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-r from-red-50 to-orange-50 border-2 border-red-200 rounded-xl p-6 my-8">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0">
          <AlertTriangle className="text-white" size={24} />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-bold text-red-900 mb-3">Important Risk Disclaimer</h3>
          
          <div className="space-y-3 text-sm text-red-800">
            <p className="font-semibold">
              ⚠️ Mutual fund investments are subject to market risks. Please read all scheme-related documents carefully before investing.
            </p>
            
            <ul className="space-y-2 ml-4 list-disc">
              <li>
                <strong>Past Performance:</strong> Past performance is not indicative of future returns. Historical returns do not guarantee future performance.
              </li>
              <li>
                <strong>Market Risk:</strong> The value of investments may fluctuate based on market conditions and can go down as well as up.
              </li>
              <li>
                <strong>No Guarantee:</strong> There is no assurance or guarantee that the objectives of any scheme will be achieved.
              </li>
              <li>
                <strong>Calculator Assumptions:</strong> All calculator projections are based on assumed rates of return and do not represent actual returns. Actual returns may vary significantly.
              </li>
              <li>
                <strong>Professional Advice:</strong> Investors should consult their financial advisors if in doubt about the suitability of any investment product.
              </li>
              <li>
                <strong>Scheme Documents:</strong> Please refer to the Scheme Information Document (SID) and Statement of Additional Information (SAI) for detailed terms and conditions.
              </li>
            </ul>

            <p className="text-xs font-semibold pt-3 border-t border-red-200">
              The calculations provided are for illustrative purposes only and should not be construed as promise or forecast of returns. 
              Mutual fund investments involve risks and investors should make informed investment decisions based on their own assessment and consultation with qualified financial advisors.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RiskDisclaimer;
